import React from "react"
import ActionButton from "./actionbutton.component"
import { FormattedMessage } from "react-intl"
import { ButtonProps } from "../types/button"

export const UnArchiveButton = (props: ButtonProps) => {
    return (
        <ActionButton
            className={"btn-warning btn btn-sm mr-2"}
            onClick={props.onClickCallback}>
            <FormattedMessage
                id="common.button.unarchive.btn"
                defaultMessage="Unarchive"
            />
        </ActionButton>
    )
}


// WEBPACK FOOTER //
// ./src/common/button/UnarchiveButton.tsx